var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useFsEntriesGetKeys } from '#query-hooks';
import { buildCrumbs, splitIntoPrefixes } from '../helpers';
export const useWebFsCrumbs = ({ currentDirPath, filespaceId, filespaceRootKey, rootName, workspaceId, }) => {
    _react_refresh_temp_1();
    const crumbPrefixes = useMemo(() => splitIntoPrefixes(currentDirPath ?? ''), [currentDirPath]);
    // Crumb ids are best-effort: a missing ancestor id shortens the trail, it never blocks the listing
    const { queries: { data: crumbPrefixKeys, isError: isCrumbsError, isPending: isPrefixKeysPending, }, } = useFsEntriesGetKeys({
        filespaceId,
        fsEntriesPaths: crumbPrefixes,
        workspaceId,
    });
    // An unknown path means the prefixes are not known yet either, otherwise the root would show alone first
    const isCrumbsPending = currentDirPath === undefined || isPrefixKeysPending;
    // Held back until every ancestor id is in, so the trail appears whole instead of one crumb at a time
    const crumbs = useMemo(() => filespaceRootKey && !isCrumbsPending
        ? buildCrumbs({
            prefixes: crumbPrefixes,
            prefixKeys: crumbPrefixKeys,
            rootCrumb: {
                id: filespaceRootKey.id,
                name: rootName,
                path: '',
            },
        })
        : undefined, [
        crumbPrefixKeys,
        crumbPrefixes,
        filespaceRootKey,
        isCrumbsPending,
        rootName,
    ]);
    return { crumbPrefixes, crumbs, isCrumbsError, isCrumbsPending };
};
_react_refresh_temp_1(useWebFsCrumbs, "1GaUnqexjN4FjC0oqACUUjTjvk8=", false, () => [useFsEntriesGetKeys]);
